import { CountUp } from 'countup.js';
import { wrapString } from '../utils/wrappers';

const numberRegex = /(?:\d{1,3}[.,]?)+\d*/;

/**
 * @description
 * Set class or id with "counter" keyword in it on mod_article.
 * Script is going to automatically find and pack up the numbers inside span.number element.
 *
 * @param {string} countersSelector - you can override the default selector, which is - '[class*="counter"], [id*="counter"]'
 * @param {string} numbersSelector - selector into element with number, default - 'p:first-child'
 * @param {object} countUpOptions - options for CountUp script - https://github.com/inorganik/countUp.js
 *
 * @example
 * <div.mod_article.counters>
 *      [...]
 *          <div.text_container>
 *              <p>2000 KwH</p>
 *          </div.text_container>
 *      [...]
 * </div.mod_article.counters>
 */
export default function countUp(
    countersSelector = '[class*="counter"], [id*="counter"]',
    numbersSelector = 'p:first-child',
    countUpOptions = { separator: '.', enableScrollSpy: true }
) {
    let sectionsWithCounters = document.querySelectorAll(countersSelector);

    sectionsWithCounters.forEach(function (section) {
        let pWithNumbers = section.querySelectorAll(numbersSelector);

        let elementsWithNumbers = [...pWithNumbers].filter((el) => numberRegex.test(el.innerText));

        elementsWithNumbers.forEach((elementWithNumber) => {
            createCounter(elementWithNumber, countUpOptions);
        });
    });
}

function createCounter(elementWithNumber, options) {
    let finalNumber = elementWithNumber.innerHTML.match(numberRegex)[0];

    elementWithNumber.innerHTML = elementWithNumber.innerHTML.replace(
        finalNumber,
        wrapString(finalNumber, 'span', {
            class: 'countUp_number',
        })
    );

    finalNumber = finalNumber.replaceAll(/[.,]/g, '');

    let numberSpan = elementWithNumber.querySelector('span.countUp_number');

    new CountUp(numberSpan, finalNumber, options);
}
